export const MIN_DIALOG_SIZE = {
    width: 386,
    height: 512,
};
export const DIALOG_DEFAULT_SIZE = {
    width: 768,
    height: 768,
};
